export interface PaginationParams {
  pageIndex: number;
  pageSize: number;
}

export const defaultPaginationParams: PaginationParams = {
  pageIndex: 1,
  pageSize: 10,
};
